export const dict = {
    Live: "Live",
    LiveStream: "LiveStream available!",
    Statistics: "Statistics available!",
    FastMarket: "FastMarket available!",
    PulseBet: "PulseBet available!",
    NoEvents: "No events were found",
    SortBy: "Sort by",
    League: "League",
    Time: "Time",
    NextUp: "Next up",
    ViewAllLink: "Go to leagues view",
    ViewAllBtn: "View All",
    ViewMore: "View More",
    ViewAllOutrights: "View All Outrights",
    HideAllOutrights: "Hide All Outrights",
    Favorites: "Favorites",
    AllEventsInFavorites: "All events are moved to Favorites",
    EachWayTag: "EW",
    Home: "1",
    Draw: "X",
    Away: "2",
    Tie: "X",
    HideAllOdds: "Hide All Odds",
    ShowAllOdds: "Show All Odds",
    "1_39": "MoneyLine",
    "2_39": "Spread",
    "3_39": "Over/Under",
    "3_714": "O/U",
    TwoBox_1_39_1: "1",
    TwoBox_1_39_2: "2",
    PointBox_3_714_1: "Points",
    PointBox_3_714_2: "Over",
    PointBox_3_714_3: "Under",
    Today: "Today",
    Tomorrow: "Tomorrow",
    "day-0": "Monday",
    "day-1": "Tuesday",
    "day-2": "Wednesdat",
    "day-3": "Thursday",
    "day-4": "Friday",
    "day-5": "Saturday",
    "day-6": "Sunday",
    "month-0": "January",
    "month-1": "February",
    "month-2": "March",
    "month-3": "April",
    "month-4": "May",
    "month-5": "June",
    "month-6": "July",
    "month-7": "August",
    "month-8": "September",
    "month-9": "October",
    "month-10": "November",
    "month-11": "December",
    "month-0-short": "Jan",
    "month-1-short": "Feb",
    "month-2-short": "Mar",
    "month-3-short": "Apr",
    "month-4-short": "May",
    "month-5-short": "Jun",
    "month-6-short": "Jul",
    "month-7-short": "Aug",
    "month-8-short": "Sep",
    "month-9-short": "Oct",
    "month-10-short": "Nov",
    "month-11-short": "Dec",
    AmericanBtnOver: "O",
    AmericanBtnUnder: "U",
    AmericanBtnMLHome: "1",
    AmericanBtnMLAway: "2",
    AmericanBtnMLDraw: "X",
    AmericanBtnMLTie: "X",
    StartedAt: "Starts At",
    StartsIn: "Starts in",
    ClockMins: "{0}'",
    NR: "NonRunner"
};
//# sourceMappingURL=dict.js.map